import { getSlots, getChannelPhone } from '@/api/networkFixer'
import { refreshProjectAndAssignChannelSlots } from '@/utils/onboardingHelpers'
import {
    OPEN_ADD_CHANNEL_BILLING_QUERY,
    OPEN_CHANNEL_CREATION_QUERY,
    getMailingConnectorsNeedingPhoneLookup,
    resolveConnectMailingChannelAction,
} from './connectMailingChannel'
import type { MailingProject } from './connectMailingChannel'

export async function hydrateMailingChannelPhones(
    store: { commit: (type: string, payload?: unknown) => void },
    projects: Array<MailingProject | null | undefined> | null | undefined
): Promise<void> {
    const connectors = getMailingConnectorsNeedingPhoneLookup(projects)
    if (!connectors.length) return

    await Promise.all(
        connectors.map(async (connector) => {
            try {
                const { data, error } = await getChannelPhone({ connectorId: connector.connectorId })
                const phone = data?.phone
                if (error || phone == null || String(phone).trim() === '') return
                store.commit('updateConnectorFields', {
                    connectorId: connector.connectorId,
                    fields: { phone: String(phone).trim() },
                })
            } catch (e) {
                // Нет номера в коннекторе и запрос не ответил — считаем, что телефона нет
            }
        })
    )
}

export async function runConnectMailingChannel({
    store,
    router,
    projectId,
    channelType,
}: {
    store: {
        dispatch: (type: string, payload?: unknown) => Promise<unknown>
        commit: (type: string, payload?: unknown) => void
        getters: { projectById?: (id: string) => MailingProject | null | undefined }
    }
    router: { push: (location: { path: string; query?: Record<string, string> } | string) => unknown }
    projectId: string
    channelType: string
}): Promise<void> {
    if (!projectId || !channelType) return

    const listedProject = store.getters.projectById?.(projectId)
    if (listedProject?.isOnBoardingActive) {
        router.push(`/project/${projectId}/onBoarding`)
        return
    }

    await refreshProjectAndAssignChannelSlots({ store, projectId })

    const project = store.getters.projectById?.(projectId) || listedProject
    if (project?.isOnBoardingActive) {
        router.push(`/project/${projectId}/onBoarding`)
        return
    }

    await hydrateMailingChannelPhones(store, [project])

    const { data: slots, error } = await getSlots({ projectId })
    const action = resolveConnectMailingChannelAction({
        project: store.getters.projectById?.(projectId) || project,
        channelType,
        slots: !error && Array.isArray(slots) ? slots : [],
    })

    if (action.kind === 'onboarding') {
        router.push(`/project/${projectId}/onBoarding`)
        return
    }

    if (action.kind === 'openConnector') {
        router.push({
            path: `/project/${projectId}`,
            query: { openConnectorSidebar: action.connectorId },
        })
        return
    }

    if (action.kind === 'createChannel') {
        const query: Record<string, string> = {
            [OPEN_CHANNEL_CREATION_QUERY]: '1',
        }
        if (action.group) query.group = action.group
        if (action.slotId) query.slotId = action.slotId
        router.push({ path: `/project/${projectId}`, query })
        return
    }

    router.push({
        path: `/project/${projectId}`,
        query: { [OPEN_ADD_CHANNEL_BILLING_QUERY]: '1' },
    })
}
